import { Component, OnDestroy } from '@angular/core';
import { ClinicsService } from '@services/clinics.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-org-clinic-general',
  templateUrl: './org-clinic-general.component.html',
  styleUrls: ['./org-clinic-general.component.less'],
})
export class OrgClinicGeneralComponent implements OnDestroy {
  unsub: Subject<void> = new Subject<void>();
  constructor() {}

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
